export default class {
    user() {
        return {
            id: null,
            intro: false,
            active: false,
            role: null,
            platformRole: null,
            workType:null,
            name: null,
            firstName: null,
            lastName: null,
            preferredName: null,
            mobileNumber: null,
            mobileNumber_verified: null,
            email: null,
            emailVerified: null,
            image: null,
            address: {
                lat: null,
                lng: null,
                text: null,
                street: null,
                suburb: null,
                state: null,
                country: null,
                postcode: null,
            },
            timeOffset: null,
            timezone: null,
            birthday: null,
            minRate: null,
            weekendRate: null,
            abn: null,
            profileRequirements: null,
            tfn:null,
            schedule: null,
            ahpra: {
                number: null,
                date: null,
            },
            billing: {
                address: {
                    text: null,
                },
                name: null,
                bankAccountName: null,
                bankBsb: null,
                bankAccountNumber: null,
                bankName:null,
                bankNameBilling:null,
                businessNameBilling:null,
                billingAccountType: null,
                routingNumber: null,
            },
            airwallexInfo:{
                accountName: null,
                accountNumber:null,
                accountRoutingType:null,
                accountRoutingValue:null,
                bankName:null,
                beneficiaryId:null,
                companyName:null,
                entitiyType:null,
                paymentMethod:null,
            },
            bankVerification:{
                accountName:null,
                accountNumber:null,
                accountType:null,
                amount:null,
                bsb:null,
                businessName:null,
                verified:null,
            },
            environment: {
                scriptsPerDay: null,
                average_scripts_saturday_id: null,
                average_scripts_sunday_id: null,
                number_of_patients: null,
                software: null,
                services: []
            },
            environmentValue: {
                scriptsPerDay: null,
                average_scripts_saturday_id: null,
                average_scripts_sunday_id: null,
                number_of_patients: null,
                software: null,
                services: []
            },
            emergencyContact: {
                firstName: null,
                lastName: null,
                mobileNumber: null
            },
            whiteLabel: {
                image: null,
                name: null,
                primaryColor: null,
                secondaryColor: null,
            },
            notifications: {
                notifyChatMessage: 0,
                notifyMatchingJob: 0,
                notifyBookedShift: 0,
                notifySubmitTimesheet: 0,
                notifyTimesheetConfirmed: 0,
                notifyPharmacyCancelShift: 0,
                notifyShiftReminderToday: 0,
                notifyShiftReminderEarly: 0,
                notifySomeoneBookedShift: 0,
                notifyVerifyTimesheet: 0,
                notifyDailyReminder: 0,
                notifyHourlyReminder: 0,
                notifyShiftApplication: 0,
            },
            languages: [null],
            gst: null,
            covid:null,
            travel: {
                workOutsideMetro: null,
                shortStint: true,
                longTermJob: null,
            },
            files: [],
            completedCancelledShiftsData: { 
                completedShiftsCount: null,
                cancelledShiftsCount: null,
                lastCompletedShiftDate: null,
                lastCancelledShiftDate: null,
                cancellationRate: null,
                totalShifts: null,
            },
            termsAndCondition:null,
            groupContract:null,
        }
    }

    job() {
        return {
            id: null,
            pharmacyId: null,
            startDate: null,
            endDate: null,
            minRate: null,
            maxRate: null,
            schedule: [],
            createdAt: null,
            pharmacy: this.user,
            locum: this.user,
        }
    }

    setting(){
        return{
            environmentValue: {
                scriptsPerDay: null,
                average_scripts_saturday_id: null,
                average_scripts_sunday_id: null,
                number_of_patients: null,
                software: null,
                services: []
            },
        }
    }

    shift() {
        return {
            confirmationDate: null,
            createdAt: null,
            date: null,
            dispute: null,
            endTime: null,
            id: null,
            jobId: null,
            pharmacy: this.user,
            locum: this.user,
            pharmacyId: null,
            startTime: null,
            status: null,
            updatedAt: null,
            userBreakMinutes: null,
            userEndTime: null,
            userId: null,
            userStartTime: null,
        }
    }

    state() {
        return {
            jobDistances:[],
            token: null,
            status: '',
            loggedIn: false,
            stripeConnectLink: '',
            stripeConnectStatus: null,
            stripeRefreshLink: '',
            paymentIntent: {},
            jobPreview: {},
            billingSession: "",
            paymentIntentCheck: false,
            stripeLoginLink: '',
            refreshJobData: {},
            guestShiftPublic:  {
                pharmacy:{},
                guest:{},
                note:null
            },
            pages: {
                backPage: null,
                auth: {
                    intro: false,
                    back: [],
                },
                verify: {
                    mobileNumber: null,
                    email: null
                },

                job: {

                    backPages: [],
                    create: {
                        shifts: [],
                        startDate: null,
                        endDate: null,
                        schedule: [],
                        minRate: null,
                        maxRate: null,
                        isBlockShift: false,
                        platform_role_id: 1,
                        covid_cert_required: 0,
                        languages_conditions: 0,
                        languages: [],
                        paying_for_travel: 0,
                        max_travel_amount:0,
                        enable_travel_allowance_for_first_and_last_day:0,
                        pay_for_flights: 0,
                        pay_for_accommodation: 0,
                        solo: 0,
                        open_up: 0,
                        close: 0,
                        admin_aids: 0,
                        home_med_review: 0,
                        num_of_tech: 0,
                        additional_notes: false,
                        notes: "",
                        parking_check: false,
                        parking: "",
                        number_of_technicians: false,
                        visibility_status: null,
                        more_option_internal_pools:{},
                        more_option_prefered_locum:{
                            value:null,
                            locums:[]
                        },
                        more_option_open_marketplace:{
                            value:null,
                            onboarding: 1,
                        },
                        more_option_agency:{
                            value:null,
                            agencies:[]
                        },
                        job_lock_hour: null,
                        dates: [],
                        saturdayMinRate:null,
                        saturdayMaxRate:null,
                        sundayMinRate:null,
                        sundayMaxRate:null,
                        weekendMinRate:null,
                        weekendMaxRate:null,
                        shift_application_type: 0,
                        application_radius: null,

                    },
                    shifts: {
                        book: {
                            shiftList: [],
                            job: null,
                        },
                        complete: {
                        }
                    },
                    details: {
                        job: null,
                        date: null
                    },
                    filters: {
                        schedule: null,
                        minRate: null,
                        weekendRate:null,
                    }
                },
                guestShift: {

                    backPages: [],
                    create: {
                        shifts: [],
                        startDate: null,
                        endDate: null,
                        schedule: [],
                        payRate: null,
                        shiftNotes:"",
                        firstName:"",
                        lastName:"",
                        email:"",
                        mobileNumber:"",
                        additionalTermCondition:"",
                        requestAphraIns:0,
                        files:[],
                        dates: [],
                        saturdayMinRate:null,
                        saturdayMaxRate:null,
                        sundayMinRate:null,
                        sundayMaxRate:null,
                        weekendMinRate:null,
                        weekendMaxRate:null

                    },
                    shifts: {
                        book: {
                            shiftList: [],
                            job: null,
                        },
                        complete: {
                        }
                    },
                    details: {
                        job: null,
                        date: null
                    },
                    filters: {
                        schedule: null,
                        minRate: null
                    }
                },
                report: {
                    backPages: [],
                    userData: null,
                    shiftData: null
                },
                dispute: {
                    backPages: [],
                    shiftData: null
                },
                jobListing:{
                    backPages: [],
                    create: {
                        job_type:null,
                        job_title: null,
                        job_location: null,
                        job_category: null,
                        job_skills:[],
                        min_rate: null,
                        max_rate: null,
                        rate_type: null,
                        bonus: null,
                        job_description:null,
                        questionary:null,
                        questions:[],
                        short_description:null,
                        job_post_payment_id:null,
                        payment_intent_id:null,
                        stripe_customer_id:null,
                        federal_pharmacist_support:null,
                        platform_role_id:null,
                        is_republish:false,
                    },
                },
                
               
            },
            user: this.user(),
            setting:this.setting(),
            common: {
                pharmacy: {
                    scriptsPerDay: [],
                    average_scripts_saturday_id: [],
                    average_scripts_sunday_id: [],
                    number_of_patients: [],
                    software: [],
                    services: [],
                },
                states: [],
            },
            shifts: [],
            jobs: [],
            languages: {
                list: []
            },
            shiftApplicationDetails:  {
              
            },
            redirectRoute: null,
            locumBlockedPharmacies: [],
            pharmacyTypes: [],
            appliedCoupon: {},
            pharmacyAdditionalInfo: {},
        }
    }
}
